import React from 'react';
import { motion } from 'framer-motion';
import ProductList from '../components/ProductList';
import AboutUs from '../components/AboutUs';
import "@fontsource/poetsen-one";
import ContactUs from '../components/ContactUs';

const fontStyle = { fontFamily: '"Poetsen One", sans-serif', fontWeight: 'normal' };

const fadeUpVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const fadeInVariant = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.8, delay: 0.3 } },
};

const HomePage = () => {
  return (
    <div
      style={{
        ...fontStyle,
        backgroundImage: 'url("https://res.cloudinary.com/dwf8ifbzs/image/upload/v1744277433/jmills_walpaper_2_wme9a7.jpg")',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}
    >
      <div className="bg-white/60 backdrop-blur-sm scroll-smooth">
        {/* Home Section */}
        <div id="home" className="relative overflow-hidden">
          <div className="absolute inset-0 -z-10 bg-[url('https://www.transparenttextures.com/patterns/leaf.png')] opacity-10" />
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 py-16 px-4 sm:px-6 lg:px-24 xl:px-32 mt-16">
            <motion.div
              className="flex flex-col justify-center text-center md:text-left"
              variants={fadeUpVariant}
              initial="hidden"
              animate="visible"
            >
              <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold leading-tight bg-gradient-to-r from-green-600 to-yellow-400 bg-clip-text text-transparent text-center md:text-left p-4 mt-8">
                Jayamal Oil Mills
              </h1>
              <p className="mt-4 text-lg sm:text-xl lg:text-2xl text-green-900 font-medium">
                Pure Goodness from Nature – Premium Coconut Oil & More
              </p>
            </motion.div>

            <motion.div
              className="flex items-center justify-center"
              variants={fadeInVariant}
              initial="hidden"
              animate="visible"
            >
              <div className="overflow-hidden max-w-full">
                <img
                  src="https://gallerypng.com/wp-content/uploads/2024/10/Coconut-Oil-Png-Picture-Free-730x750.png"
                  alt="Coconut Oil"
                  className="w-full h-auto object-cover"
                />
              </div>
            </motion.div>
          </div>
        </div>

        {/* Product Section */}
        <motion.section
          id="products"
          className="relative px-4 sm:px-6 lg:px-20 bg-gradient-to-b from-amber-50 via-white to-green-50"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="max-w-7xl mx-auto sm:p-10 md:p-14">
            <ProductList />
          </div>
        </motion.section>

        {/* About Us */}
        <motion.div
          id="about"
          className="pb-12 px-4 sm:px-6 lg:px-20"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <AboutUs />
        </motion.div>

        {/* Contact Us */}
        <motion.div
          id="contact"
          className="py-12 px-4 sm:px-6 lg:px-20 bg-white/70"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
        <ContactUs/>
        </motion.div>
      </div>
    </div>
  );
};

export default HomePage;
